var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-payment-status"},[_c('viewWrapper',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('p24',{attrs:{"endProcess":true,"state":_vm.status}}),_c('ADService')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }